import 'react-app-polyfill/ie11';
import 'react-app-polyfill/stable';

import React from 'react';
import ReactDOM from 'react-dom';

import App from './MainApp';
import * as serviceWorker from './serviceWorker';
import './_i18n';

ReactDOM.render(<App />, document.getElementById('root'));

// console.info(`Landing-UI-released on:${process.env.REACT_APP_BUILD_TIME}`);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
